var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Pricing")]),
      _vm._l(_vm.entity.pricing, function(pricing, index) {
        return _c(
          "md-layout",
          { key: index, attrs: { "md-gutter": 24 } },
          [
            _c(
              "md-layout",
              { attrs: { "md-flex": "50", "md-flex-small": "100" } },
              [
                _c("price-unit-selector", {
                  model: {
                    value: _vm.entity.pricing[index].unit,
                    callback: function($$v) {
                      _vm.$set(_vm.entity.pricing[index], "unit", $$v)
                    },
                    expression: "entity.pricing[index].unit"
                  }
                })
              ],
              1
            ),
            _c(
              "md-layout",
              { attrs: { "md-flex": "50", "md-flex-small": "100" } },
              [
                _c("price-input", {
                  model: {
                    value: _vm.entity.pricing[index].price,
                    callback: function($$v) {
                      _vm.$set(_vm.entity.pricing[index], "price", $$v)
                    },
                    expression: "entity.pricing[index].price"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37ea6890", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37ea6890","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/PricingForm.vue
// module id = 870
// module chunks = 0